import React from "react";
 
const iconFor = (condition) => {
  const c = condition.toLowerCase();
 
  if (c.includes("rain") || c.includes("drizzle") || c.includes("thunder")) {
    return (
      <svg
        viewBox="0 0 64 64"
        width="32"
        height="32"
        fill="none"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-label="Rain"
        role="img"
      >
        <path d="M20 38h22a12 12 0 0 0 0-24 15 15 0 0 0-29-2A10 10 0 0 0 20 38Z" />
        <path d="M22 46l-3 6M32 46l-3 6M42 46l-3 6" />
      </svg>
    );
  }
 
  if (c.includes("snow")) {
    return (
      <svg
        viewBox="0 0 64 64"
        width="32"
        height="32"
        fill="none"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-label="Snow"
        role="img"
      >
        <path d="M18 38h28a12 12 0 0 0 0-24 16 16 0 0 0-31-2A10 10 0 0 0 18 38Z" />
        <path d="M24 50l2-4M30 50v-6M36 50l-2-4" />
      </svg>
    );
  }
 
  if (c.includes("cloud")) {
    return (
      <svg
        viewBox="0 0 64 64"
        width="32"
        height="32"
        fill="none"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinejoin="round"
        aria-label="Cloud"
        role="img"
      >
        <path d="M18 42h28a12 12 0 0 0 0-24 16 16 0 0 0-31-2A10 10 0 0 0 18 42Z" />
      </svg>
    );
  }
 
  return (
    <svg
      viewBox="0 0 64 64"
      width="32"
      height="32"
      fill="none"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
      aria-label="Sun"
      role="img"
    >
      <circle cx="32" cy="32" r="12" />
      <path d="M32 6v8M32 50v8M6 32h8M50 32h8M12.6 12.6l5.6 5.6M45.8 45.8l5.6 5.6M12.6 51.4l5.6-5.6M45.8 18.2l5.6-5.6" />
    </svg>
  );
};
 
const ForecastCard = ({ forecast }) => {
  if (!forecast || forecast.length === 0) return null;
 
  return (
    <div className="forecast-container">
      <h3 className="forecast-title">5-Day Forecast</h3>
      <div className="forecast-strip">
        {forecast.map((day) => (
          <div key={day.label} className="forecast-day">
            <span className="forecast-label">{day.label}</span>
            <div className="forecast-icon">{iconFor(day.condition)}</div>
            <span className="forecast-condition">{day.condition}</span>
            <strong className="forecast-high">{day.high}°</strong>
            <span className="forecast-low">{day.low}°</span>
          </div>
        ))}
      </div>
    </div>
  );
};
 
export default ForecastCard;
 
